import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import queryString from 'query-string';
import { Table } from '@components';
import { paymentReceiptColumn } from '../../utils/columnDefinition';

class PaymentReceiptTable extends Component {
	shouldComponentUpdate = ({ data, loading }) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.data, data)
			|| !isEqual(lastProps.loading, loading)
		);
	};

	handleOnClickInvoiceId = ({ id, statusId }) => {
		const { dispatch } = this.props;

		if (id && [2, 4, 5, 6, 7].indexOf(statusId) !== -1) {
			dispatch(push({ pathname : `/payments/${id}`, search : queryString.stringify({ fromReports : true }) }));
		}
	}

	render() {
		const { data, loading } = this.props;
		return (
			<div className="payment-receipt-table client-portal-list-table">
				<Table
					columns={paymentReceiptColumn(this.handleOnClickInvoiceId)}
					data={data}
					loading={loading}
					isReceiptTable
				/>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({ dispatch });

PaymentReceiptTable.propTypes = {
	data     : PropTypes.array,
	dispatch : PropTypes.func.isRequired,
	loading  : PropTypes.bool,
};

PaymentReceiptTable.defaultProps = {
	data    : [],
	loading : false,
};

export default connect(null, mapDispatchToProps)(PaymentReceiptTable);
